import type { FaireProductEntity } from "../../entity_types/product";

export const p_y58mgwambh: FaireProductEntity = {
  token: "p_y58mgwambh",
  type: "product",
  name: '31.5" Vertical Wooden Sunflower Welcome Sign',
  brandName: "Tremont Floral Supplies",
  imageUrl:
    "https://cdn.faire.com/fastly/564f98a1e2fc6c03ed73a047e9a6055df5fe96f917cea1e52b3ad1377746a59a.jpeg",
  priceDollars: 7.22,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7e3e7d2ed419978e0262d6fbbc610aee8019fcba229fcf29fd8d26c4114de52a.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
